export default __webpack_public_path__ + "static/media/IMG_0037_2_11zon.06dacfeb.jpg";